import ToggleButtonGroup, {
  ToggleOption,
} from '../../../../components/Forms/Buttons/ToggleButtonGroup';
import InputField from '../../../../components/Forms/Input/InputField';
import SearchInputField from '../../../../components/Forms/Input/SearchInputField';
import SelectField from '../../../../components/Forms/Input/SelectField';
import { IProductUnit } from '../../../../types/productUnit/productUnitInterfaces';

export type UnitConversionStatusFilter = 'ALL' | 'ACTIVE' | 'INACTIVE';

interface Props {
  units: IProductUnit[];
  search: string;
  fromUnitId: number;
  toUnitId: number;
  rawMaterialId: number;
  status: UnitConversionStatusFilter;
  onSearchChange: (value: string) => void;
  onFromUnitChange: (value: number) => void;
  onToUnitChange: (value: number) => void;
  onRawMaterialChange: (value: number) => void;
  onStatusChange: (value: UnitConversionStatusFilter) => void;
}

const statusOptions = [
  { value: 'ALL', label: 'Todas' },
  { value: 'ACTIVE', label: 'Activas' },
  { value: 'INACTIVE', label: 'Inactivas' },
] satisfies ToggleOption<UnitConversionStatusFilter>[];

const unitOption = (unit: IProductUnit) => ({
  value: unit.id,
  label: unit.unitCode ? `${unit.name} (${unit.unitCode})` : unit.name,
});

const UnitConversionFilters = ({
  units,
  search,
  fromUnitId,
  toUnitId,
  rawMaterialId,
  status,
  onSearchChange,
  onFromUnitChange,
  onToUnitChange,
  onRawMaterialChange,
  onStatusChange,
}: Props) => (
  <div className="grid grid-cols-1 gap-4 border-b border-stroke bg-gray-2/40 p-5 dark:border-strokedark dark:bg-boxdark-2/30 md:grid-cols-2 xl:grid-cols-[minmax(220px,1fr)_repeat(3,minmax(150px,200px))_auto] xl:items-end">
    <div className="xl:pb-5">
      <SearchInputField
        label="Buscar"
        name="unitConversionSearch"
        value={search}
        iconKey="search"
        placeholder="Unidad, código o materia prima..."
        withMargin={false}
        onChange={(event) => onSearchChange(event.target.value)}
      />
    </div>

    <SelectField
      label="Unidad origen"
      name="unitConversionFromUnit"
      value={fromUnitId}
      iconKey="scale"
      options={[{ value: 0, label: 'Todas' }, ...units.map(unitOption)]}
      onChange={(event) => onFromUnitChange(Number(event.target.value))}
    />

    <SelectField
      label="Unidad destino"
      name="unitConversionToUnit"
      value={toUnitId}
      iconKey="scale"
      options={[{ value: 0, label: 'Todas' }, ...units.map(unitOption)]}
      onChange={(event) => onToUnitChange(Number(event.target.value))}
    />

    <InputField
      label="ID materia prima"
      name="unitConversionRawMaterialId"
      type="number"
      iconKey="hash"
      min={1}
      value={rawMaterialId || ''}
      placeholder="Todas"
      onChange={(event) =>
        onRawMaterialChange(Number(event.target.value) || 0)
      }
    />

    <ToggleButtonGroup
      value={status}
      options={statusOptions}
      onChange={onStatusChange}
      className="mb-5"
    />
  </div>
);

export default UnitConversionFilters;
